const constants = [
  {
    date: "Dec 8, 2023",
    title: "Automated Node Health Checks are now Live and Integrated",
    description:
      "In a major update, 'Automated Node Health Checks' are now live and fully integrated into the primary on-chain subscription plan.",
    btn: {
      title: "Read More",
      link: "https://medium.com/sentinel/automated-node-health-checks-are-now-live-and-integrated-2819f633257a",
    },
  },
  {
    date: "Nov 3, 2023",
    title: "Re-Launch of Sentinel's Stats Page Stats.Sentinel.co",
    description:
      "The Sentinel stats page has now been re-launched, offering a clear insight into key metrics involving dVPN nodes as well as dVPN usage trends.",
    btn: {
      title: "Read More",
      link: "https://medium.com/sentinel/re-launch-of-sentinels-stats-page-stats-sentinel-co-96efac31bbcb",
    },
  },
  {
    date: "Sept 9, 2023",
    title:
      "Introduction of On-Chain Subscriptions and Time Based Payments- Sentinel's Biggest dVPN Protocol Upgrade yet",
    description:
      "In this we discuss Sentinel's latest protocol significance, as well as the commands required to make use of it and running your own dVPN application on Sentinel.",
    btn: {
      title: "Read More",
      link: "https://medium.com/sentinel/introduction-of-on-chain-subscriptions-and-time-based-payments-sentinels-biggest-dvpn-protocol-a2b240199f18",
    },
  },
];

export default constants;
